import EventBus from "../events/EventBus";
var RECAPTCHA_API_URL = 'https://www.google.com/recaptcha/api.js';
EventBus.on('modal:open', function (modal) {
    var _a;
    var key = (_a = modal === null || modal === void 0 ? void 0 : modal.dataset) === null || _a === void 0 ? void 0 : _a.recaptcha;
    if (!key || !window.grecaptcha) {
        return;
    }
    setTimeout(function () {
        grecaptcha.ready(function () {
            grecaptcha.execute(key, { action: modal.id.replace(/^mm-/, '').replace('-', '_') })
                .then(function (token) {
                modal.querySelector('[name=recaptcha]').value = token;
            });
        });
    }, 500);
});
var onLoadCallbackName = 'onRecaptchaLoad';
var callbacks = [];
var loading = false;
window[onLoadCallbackName] = function () {
    loading = false;
    callbacks.forEach(function (resolve) { return resolve(window.grecaptcha); });
};
export function useRecaptcha() {
    return new Promise(function (resolve, fail) {
        if (window.grecaptcha) {
            resolve(grecaptcha);
            return;
        }
        callbacks.push(resolve);
        if (loading) {
            return;
        }
        loading = true;
        var script = document.createElement('script');
        script.src = "".concat(RECAPTCHA_API_URL, "?onload=").concat(onLoadCallbackName, "&render=").concat(process.env.RECAPTCHA_KEY);
        script.async = true;
        script.defer = true;
        script.onerror = function () { return fail('Failed to load Google Recaptcha'); };
        document.body.append(script);
    });
}
